export default "__VITE_ASSET__jKeEzSV0__"